import { render, staticRenderFns } from "./AdminFirstTimers.vue?vue&type=template&id=3a8dd12a&"
import script from "./AdminFirstTimers.vue?vue&type=script&lang=js&"
export * from "./AdminFirstTimers.vue?vue&type=script&lang=js&"
import style0 from "./AdminFirstTimers.vue?vue&type=style&index=0&id=3a8dd12a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports